// LoadingState.jsx
import React from 'react';

const LoadingState = () => (
  <div className="course-structure">
    <div className="loading-state">
      Loading course structure...
    </div>
  </div>
);

export default LoadingState;